export const track = (eventName, eventDetails) => {
  if (eventDetails) {
    mixpanel.track(eventName, eventDetails)
  } else {
    mixpanel.track(eventName)
  }
}

export const identify = (args) => {
  mixpanel.identify(args)
}

export const register = (args) => {
  mixpanel.register(args)
}

export const tracking = {
  track,
  identify,
  register
}

export const TrackingEvents = {
  /* Refactored calling code to use the following events */
  scenario: {
    implement: 'Retirement Scenario: Implement',
    approve: 'Retirement Scenario: Approve',
    exportCapitalGrowth: 'Scenario planning: Export capital growth',
    downloadPDF: 'Scenario planning: Download PDF',
  },

  implementedPlan: {
    exportCapitalGrowth: 'Implemented plan: Export capital growth',
    downloadPDF: 'Dashboard: Download PDF',
    sendPDF: 'Dashboard: Send PDF Report',
    openGetAstuteReportModal: 'Dashboard: Open Get Astute Report Modal',
    getAstuteReport: 'Dashboard: Get Astute Report',
    viewAstuteReport: 'Dashboard: View Astute Report'
  },

  jointPlan: {
    create: 'Joint planning: Create',
    view: 'Joint plan: View',
    delete: 'Joint plan: Delete',
    downloadPDF: 'Joint plan: Download PDF'
  },

  /* These events only used in Rails but have been added here for completeness.
   * Note the events are active but are defined as string literals. If these
   * grow to be used from both Rails and JS, this TrackingEvents definition
   * should move to Rails and be passed down in the 'session' payload once the
   * user logs in. */
  noCategory: {
    sendClientInvite: 'Send Client Invite',
    viewClientDashboard: 'View Client Dashboard',
    convertProspect: 'Convert prospect',
    onboardForClient: 'Onboard for client',
    onboardForProspect: 'Onboard for prospect'
  }
}

